import useUIContext from '../ui/use-ui-context';

/**
 *  use contextOverride and pass the context from outside if you want to use query encoder/decoder from outside of the context
 *
 * @param {string|null} [contextOverride=null]
 * @returns {{ queryDecoder: (arg: Location<any> | string) => {pathname: unknown} }|undefined}
 */
const useQueryCodec = (contextOverride = null) => {
	const { within: withinActual, contexts } = useUIContext();
	const within = contextOverride ?? withinActual;
	return contexts.find(({ key }) => within === key);
};

export default useQueryCodec;
